import { LabFeatureFlags } from 'constants/lab'
import { useLabFeatureFlag } from 'hooks/FeatureFlag/useLabFeatureFlag'
import { useLocaleUrlOptions } from 'hooks/useLocaleUrlOptions'

export function useVisibleLanguageOptions() {
  const languageSelectorFlag = useLabFeatureFlag(
    LabFeatureFlags.enableLanguageSelector,
  )
  const { languageOptions } = useLocaleUrlOptions()
  const showLanguageSelector =
    Boolean(languageSelectorFlag?.enabled) && languageOptions.length > 1

  return { languageOptions, showLanguageSelector }
}
